import { useQueryParams } from 'hooks/useQueryParams'
import { useMemo } from 'react'

import { ArticleView, HandbookSortOptions, HandbookV2, HandbookViewMode } from '../../types'
import { useArticleView } from '../../providers/ArticleViewProvider/ArticleViewProvider'
import { useFolder } from 'hooks/queries/folders/useFolder'
import { useRootStore } from 'stores/RootStore'

export const useHandbook = () => {
  return useRootStore().handbooks.currentHandbook?.handbook || null
}

// Returns the top level handbook folder
export const useHandbookFolder = () => {
  const handbook = useHandbook()
  return useFolder(handbook?.folder?.key || null).data?.folder
}

export const useHandbookBreadcrumb = () => {
  const handbook = useHandbook()
  const articleView = useArticleView()
  const { prevHandbook } = useQueryParams()
  const readMode = useMemo(() => handbook?.view_mode === HandbookViewMode.Read, [handbook])
  const commentMode = useMemo(() => handbook?.view_mode === HandbookViewMode.Comment, [handbook])
  const showBreadcrumb = useMemo(
    () => handbook && !prevHandbook && articleView !== ArticleView.Editing,
    [handbook, prevHandbook, articleView],
  )

  return {
    handbook,
    prevHandbook,
    readMode,
    commentMode,
    showBreadcrumb,
  }
}

export const useHandbookPermissions = (handbook?: HandbookV2 | null) => {
  const canEdit =
    !!handbook &&
    !!handbook.current_user_access &&
    ['owner', handbook.folder && 'edit'].includes(handbook.current_user_access)

  const canDrag = !!handbook && handbook.sort_type === HandbookSortOptions.Custom && canEdit

  return { canEdit, canDrag }
}
